<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button size="mini" type="primary" v-if="!editing"  @click="editing = true">编辑</el-button>
                <el-button size="mini" type="primary" v-if="editing" @click="add">添加</el-button>
                <el-button size="mini" type="primary" v-if="editing" @click="save">保存</el-button>
                <el-button size="mini" type="primary" v-if="editing" @click="cancel">取消</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="图片" width="400">
                    <template slot-scope="scope">
                        <el-upload :disabled="!editing" class="uploadPicture" action="/api/uploadImage" 
                        :show-file-list="false" 
                        :before-upload="beforeUpload"
                        :on-success="(response, file, fileList) => uploadPictureSuccess(response, file, fileList, scope.row)">
                            <img v-if="scope.row.url" :src="scope.row.url" width="100%">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </template>
                </el-table-column>
                <el-table-column  prop="link" label="跳转地址">
                    <template slot-scope="scope">
                        <label v-if="!editing" >{{ scope.row.link}}</label>
                        <el-input v-if="editing" placeholder="请输入跳转链接" v-model="scope.row.link" clearable></el-input>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">
                        <label  v-if="!editing" >{{ scope.row['remark']}}</label>
                        <el-input  v-if="editing" v-model="scope.row.remark" clearable></el-input>
                    </template>
                </el-table-column> -->
                <el-table-column prop="state" label="状态" width="80">
                    <template slot-scope="scope" >
                        <el-switch :disabled="!editing"
                            v-model="scope.row.state"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value=1
                            :inactive-value=0
                            >
                        </el-switch>
                    </template>    
                </el-table-column>
                
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" :disabled="!editing" @click="moveUpward(scope.$index, scope.row)">上移</el-button>
                        <el-button type="primary" size="mini" :disabled="!editing" @click="moveDown(scope.$index, scope.row)">下移</el-button>
                        <el-button type="danger" size="mini"  :disabled="editing" @click="del(scope.row)">删除</el-button>                    
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name:"carousel",
    data() {
        return {
            editing:false,
            tableData: [],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        //获取数据
        async getData() {
            let res = await this.$axios.get('/manage/carousel/selectAll',this.searchParam);
            if (res.code == 200) {
                this.tableData = res.data;
            } else {
                this.$message.error(res.errMsg);
            }
        },
        //轮播向上移动
        moveUpward(index, row) {
            if (index == 0) {
                return;
            }
            let tmp = this.tableData[index];
            this.$set(this.tableData, index, this.tableData[index - 1]);
            this.$set(this.tableData, index - 1, tmp);
        },
        //轮播向下移动
        moveDown(index, row){
            if (index == this.tableData[index - 1]) {
                return;
            }
            let tmp = this.tableData[index];
            this.$set(this.tableData, index, this.tableData[index + 1]);
            this.$set(this.tableData, index + 1, tmp);
        },
        add() {
            this.tableData.push({});
        },
        async save() {
            console.debug(this.tableData);
            let res = await this.$axios.post('/manage/carousel/insertOrupdateBatch',this.tableData);
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }
            this.getData();
            this.editing = false;
        },
        cancel() {
            this.getData();
            this.editing = false;
        },
        beforeUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        uploadPictureSuccess(res, file, fileList, row) {
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }
            this.$set(row, 'url', res.data);
        },
        async del(row){
            let confirm = await this.$confirm("此操作讲永久删除图片，是否继续？","提示", {type :'warning'}).catch(err =>{return Promise.resolve(false)});
            if (!confirm) {
                return;
            }
            let res = await this.$axios.get(`/manage/carousel/delete/${row.id}`);
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.del-dialog-cnt {
    font-size: 16px;
    text-align: center;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.uploadPicture {
    width: 400px;
    height: auto;
    line-height: 0px;
}
</style>
